import styled from "styled-components";
import { TabButton } from "@sonder/ui/source/styled/fragments/TabButton";
import { borders, colors } from "@sonder/ui/source/styled/theme";

export const TabGroup = styled.div`
  align-items: center;
  background: ${colors.white};
  border-bottom: ${borders.standard};
  box-sizing: border-box;
  display: inline-flex;
  display: inline-flex;
  justify-content: flex-start;
  padding: 0 1.5rem;
  position: relative;
  width: 100%;

  > ${TabButton} {
    transform: translateY(1px);
    &:not(:last-child) {
      margin-right: 1rem;
    }
  }
`;
